// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KJ7Pl","left":"styles_left__VD7vC"};